import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'itpx-content-tile-invalid',
  templateUrl: './content-tile-invalid.component.html',
  styleUrls: ['../../common/style.css', './content-tile-invalid.component.css']
})
export class ContentTileInvalidComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/content-tile-invalid/content-tile-invalid.component.ts